<template>
    <div>
        <div class="card">
          <div class="bg-dark card-header text-white">Academic Indirect Cost Distribution - Summary</div>
          <div class="card-body">
              <div class="row mb-3">
                <div class="col text-right">
                  <button @click="downloadAICAccountDetailsReport()" :disabled="isDownloading" class="btn btn-secondary d-print-none"><i
                          class="fa fa-file-pdf"></i> Report
                  </button>                  
                </div>
              </div>
              <AppLoadingContainer :predicate="isLoading">
                <div v-if="!isLoading" class="table-responsive">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th style="width: 200px !important;"></th>
                                <th style="width: 100px !imporatnt;">AdLoc</th>
                                <th>Department Name</th>
                                <th style="width: 100px !important;">TTI Account (GL)</th>
                                <th style="width: 100px !important;">TTI Object Code</th>
                                <th style="width: 100px !important;">Department Account (GL)</th>
                                <th style="width: 150px !important;">Department Object Code</th>
                                <th style="width: 100px !important;text-align: end;">Total Amount Paid</th>                   
                                <th style="width: 100px !important;text-align: end;">Total IDC Credit</th>
                                <th style="width: 100px !important;text-align: end;">Total Department IDC Credit</th>
                                <th style="width: 100px !important;text-align: end;">Total PI IDC Credit</th>
                                <th style="width: 100px !important;text-align: end;">Total RDF Credit</th>
                            </tr>
                      </thead>
                      <tbody>
                          <template v-for="(adLoc, index) in adLocs">
                            <tr :key="index">
                              <td>
                                <div class="row">
                                  <div class="col-4 col-lg-3">
                                    <a @click="toggleAccounts(index)" class="ml-3">
                                      <i v-if="!adLoc.showAccounts" class="fa fa-caret-down fa-lg" />
                                      <i v-if="adLoc.showAccounts" class="fa fa-caret-up fa-lg" />
                                    </a>
                                  </div>
                                  <div class="btn-group col-auto ml-2">
                                      <router-link :to="{name:'AdLoc', params:{ adLoc: adLoc.adLoc, fiscalYear: fiscalYear, payPeriodStartDate: payPeriodStartDate, isCompleted: isCompleted, departmentName: adLoc.departmentName, canEdit: canEdit }}"
                                                  class="btn btn-sm btn-primary d-print-none"
                                                  data-toggle="tooltip"
                                                  title="View AdLoc">
                                          Select
                                      </router-link>
                                      <button v-if="canEdit" @click="onEditAdLoc(adLoc)" class="btn btn-warning btn-sm d-print-none" title="Edit AdLoc"
                                              type="button"><i class="fa fa-pencil-alt"></i>
                                      </button>
                                  </div>
                                </div>
                              </td>
                              <td>{{ adLoc.adLoc }}</td>
                              <td>{{ adLoc.departmentName }}</td>
                              <td>{{ adLoc.ttiAccountGL }}</td>
                              <td>{{ adLoc.ttiObjectCode }}</td>
                              <td>{{ adLoc.departmentGL }}</td>
                              <td>{{ adLoc.departmentObjectCode }}</td>
                              <td style="text-align: end;">{{ adLoc.amountPaid | currency }}</td>
                              <td style="text-align: end;">{{ adLoc.idcCredit | currency }}</td>
                              <td style="text-align: end;">{{ adLoc.departmentIDCCredit | currency }}</td>
                              <td style="text-align: end;">{{ adLoc.piidcCredit | currency }}</td>
                              <td style="text-align: end;">{{ adLoc.rdfCredit | currency }}</td>
                            </tr>
                            <tr v-if="adLoc.showAccounts" :key="index">
                              <td style="padding-left: 0px;padding-right: 0px;" colspan="2"></td>
                              <td style="padding: 0px;" colspan="10">
                                <table class="table table-sm accounts-table">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th style="width: 100px !important;">SL</th>
                                      <th style="width: 100px !important;">SA</th>
                                      <th style="width: 100px !important;">SL</th>
                                      <th style="width: 150px !important;">SA</th>
                                      <th style="width: 100px !important;text-align: end;">Amount Paid</th>                   
                                      <th style="width: 100px !important;text-align: end;">IDC Credit</th>
                                      <th style="width: 100px !important;text-align: end;">Department IDC Credit</th>
                                      <th style="width: 100px !important;text-align: end;">PI IDC Credit</th>
                                      <th style="width: 100px !important;text-align: end;">RDF Credit</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="ttiAccount in adLoc.ttiAccounts" :key="ttiAccount">
                                      <td style="text-align: end;padding-right:20px;">
                                        <button v-if="canEdit" @click="onEditAccounts(adLoc, ttiAccount)" class="btn btn-warning btn-sm d-print-none" title="Edit Accounts"
                                                type="button"><i class="fa fa-pencil-alt"></i>
                                        </button>
                                      </td>
                                      <td>{{ ttiAccount.ttiAccountSL }}</td>
                                      <td>{{ ttiAccount.ttiAccountSA }}</td>
                                      <td>{{ ttiAccount.departmentSL }}</td>
                                      <td>{{ ttiAccount.departmentSA }}</td>
                                      <td style="text-align: end;">{{ ttiAccount.amountPaid | currency }}</td>
                                      <td style="text-align: end;">{{ ttiAccount.idcCredit | currency }}</td>
                                      <td style="text-align: end;">{{ ttiAccount.departmentIDCCredit | currency }}</td>
                                      <td style="text-align: end;">{{ ttiAccount.piidcCredit | currency }}</td>
                                      <td style="text-align: end;">{{ ttiAccount.rdfCredit | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="5" style="font-weight: bold;text-align: end;">Total</td>
                                      <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ adLoc.amountPaid | currency }}</td>
                                      <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ adLoc.idcCredit | currency }}</td>
                                      <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ adLoc.departmentIDCCredit | currency }}</td>
                                      <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ adLoc.piidcCredit | currency }}</td>
                                      <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ adLoc.rdfCredit | currency }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </template>
                          <tr>
                            <td colspan="7" style="font-weight: bold;text-align: end;">ADLOC Total</td>
                            <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ totalAmountPaid | currency }}</td>
                            <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ totalIDCCredit | currency }}</td>
                            <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ totaldepartmentIDCCredit | currency }}</td>
                            <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ totalPIIDCCredit | currency }}</td>
                            <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align: end;">{{ totalRDFCredit | currency }}</td>
                          </tr>
                      </tbody>
                    </table>
                </div>
              </AppLoadingContainer>
          </div>
      </div>
      <AppModal @close="onEditAdLocClose()" v-if="isEditAdLocModalVisible">
        <template v-slot:header>Edit</template>
        <form @submit.prevent="onEditAdLocSubmit()">
            <transition name="fade">
                <AppNotification :type="alertMessage.type" v-if="alertMessage.message">
                    {{alertMessage.message}}
                </AppNotification>
            </transition>
            <div class="form-group">
                <label for="newAdLoc">Administrative Location</label>
                <input :class="{'is-invalid': $v.newAdLoc.$invalid}" class="form-control" v-model="newAdLoc" />
                <span class="invalid-feedback" v-if="!$v.newAdLoc.required">Field is required</span>
            </div>
            <div class="form-group">
                <label for="newDepartmentName">Department Name</label>
                <input :class="{'is-invalid': $v.newDepartmentName.$invalid}" class="form-control" v-model="newDepartmentName" />
                <span class="invalid-feedback" v-if="!$v.newDepartmentName.required">Field is required</span>
            </div>
        </form>
        <template v-slot:footer>
            <button :disabled="isSubmitting" @click.prevent="onEditAdLocSubmit()" class="btn btn-primary" type="submit">Save
            </button>
            <button :disabled="isSubmitting" @click="onEditAdLocClose()" class="btn btn-danger" data-dismiss="modal"
                    type="button">
                Close
            </button>
        </template>
      </AppModal>
      <AppModal @close="onEditAccountsClose()" v-if="isEditAccountsModalVisible">
        <template v-slot:header>Edit</template>
        <form @submit.prevent="onEditAccountsSubmit()">
            <transition name="fade">
                <AppNotification :type="alertMessage.type" v-if="alertMessage.message">
                    {{alertMessage.message}}
                </AppNotification>
            </transition>
            <div class="form-group">
                <label for="newTTIAccountGL">TTI Account GL</label>
                <input :class="{'is-invalid': $v.newTTIAccountGL.$invalid}" class="form-control" v-model="newTTIAccountGL" />
                <span class="invalid-feedback" v-if="!$v.newTTIAccountGL.required">Field is required</span>
            </div>
            <div class="form-group">
                <label for="newTTIAccountSL">TTI Account SL</label>
                <input :class="{'is-invalid': $v.newTTIAccountSL.$invalid}" class="form-control" v-model="newTTIAccountSL" />
                <span class="invalid-feedback" v-if="!$v.newTTIAccountSL.required">Field is required</span>
            </div>
            <div class="form-group">
                <label for="newTTIAccountSA">TTI Account SA</label>
                <input :class="{'is-invalid': $v.newTTIAccountSA.$invalid}" class="form-control" v-model="newTTIAccountSA" />
                <span class="invalid-feedback" v-if="!$v.newTTIAccountSA.required">Field is required</span>
            </div>
            <div class="form-group">
                <label for="newDepartmentGL">Department GL</label>
                <input :class="{'is-invalid': $v.newDepartmentGL.$invalid}" class="form-control" v-model="newDepartmentGL" />
                <span class="invalid-feedback" v-if="!$v.newDepartmentGL.required">Field is required</span>
            </div>
            <div class="form-group">
                <label for="newDepartmentSL">Department SL</label>
                <input :class="{'is-invalid': $v.newDepartmentSL.$invalid}" class="form-control" v-model="newDepartmentSL" />
                <span class="invalid-feedback" v-if="!$v.newDepartmentSL.required">Field is required</span>
            </div>
            <div class="form-group">
                <label for="newDepartmentSA">Department SA</label>
                <input :class="{'is-invalid': $v.newDepartmentSA.$invalid}" class="form-control" v-model="newDepartmentSA" />
                <span class="invalid-feedback" v-if="!$v.newDepartmentSA.required">Field is required</span>
            </div>
        </form>
        <template v-slot:footer>
            <button :disabled="isSubmitting" @click.prevent="onEditAccountsSubmit()" class="btn btn-primary" type="submit">Save
            </button>
            <button :disabled="isSubmitting" @click="onEditAccountsClose()" class="btn btn-danger" data-dismiss="modal"
                    type="button">
                Close
            </button>
        </template>
      </AppModal>
    </div>
</template>

<script>
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import AcademicIndirectCostService from "../../services/AcademicIndirectCostService";
    import { currency } from "../../filters/Currency";
    import AppModal from "@/components/shared/AppModal.vue"
    import {ToastType} from "@/services/models/shared/ToastType";
    import {required} from "vuelidate/lib/validators";

    export default {
        components: {
            AppModal,
            AppLoadingContainer
        },
        props: {
          fiscalYear: {
            required: true,
            type: Number
          },
          payPeriodStartDate: {
            required: true,
            type: Date
          },
          canEdit: {
            required: true,
            type: Boolean
          }
        },
        filters: {
            currency
        },
        data() {
            return {
                adLocs: [],
                isDownloading: false,
                isLoading: false,
                filterOptions: {
                  payPeriodStartDate: null
                },
                alertMessage: {
                    type: null,
                    message: null
                },
                isSubmitting: false,
                previousAdLoc: null,
                previousDepartmentName: null,
                newAdLoc: null,
                newDepartmentName: null,
                isEditAdLocModalVisible: false,
                adLoc: null,
                departmentName: null,
                previousTTIAccountGL: null,
                previousTTIAccountSL: null,
                previousTTIAccountSA: null,
                previousDepartmentGL: null,
                previousDepartmentSL: null,
                previousDepartmentSA: null,
                newTTIAccountGL: null,
                newTTIAccountSL: null,
                newTTIAccountSA: null,
                newDepartmentGL: null,
                newDepartmentSL: null,
                newDepartmentSA: null,
                isEditAccountsModalVisible: false
            }
        },
        computed: {
          totalAmountPaid() {
            return this.adLocs.map((obj) => { return obj.amountPaid }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totalIDCCredit() {
            return this.adLocs.map((obj) => { return obj.idcCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totaldepartmentIDCCredit() {
            return this.adLocs.map((obj) => { return obj.departmentIDCCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totalPIIDCCredit() {
            return this.adLocs.map((obj) => { return obj.piidcCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totalRDFCredit() {
            return this.adLocs.map((obj) => { return obj.rdfCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          }
        },
        methods: {
            /**
             * @description Loads the data from the API
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                AcademicIndirectCostService.getAdLocs(vm.filterOptions)
                    .then(response => {
                        vm.adLocs = response.map((obj) => { return {...obj, showAccounts: false }});
                    })
                    .catch(() => {
                        vm.redirectToError()
                    })
                    .finally(() => {
                        vm.isLoading = false;
                    })
            },
            
            toggleAccounts (index) {
              this.adLocs[index].showAccounts = !this.adLocs[index].showAccounts;
            },

            onEditAdLoc (adLoc) {
              this.previousAdLoc = adLoc.adLoc;
              this.previousDepartmentName = adLoc.departmentName;
              this.newAdLoc = adLoc.adLoc;
              this.newDepartmentName = adLoc.departmentName;
              this.isEditAdLocModalVisible = true;
            },

            onEditAdLocClose () {
              this.alertMessage.type = null;
              this.alertMessage.message = null;
              this.previousAdLoc = null;
              this.previousDepartmentName = null;
              this.newAdLoc = null;
              this.newDepartmentName = null;
              this.isEditAdLocModalVisible = false;
            },

            onEditAdLocSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.newAdLoc.$invalid
                    || this.$v.newDepartmentName.$invalid
                ) {
                    return;
                }

                vm.isSubmitting = true;
                AcademicIndirectCostService.updateAdLoc({
                    payPeriodStartDate: this.payPeriodStartDate,
                    previousAdLoc: this.previousAdLoc,
                    previousDepartmentName: this.previousDepartmentName,
                    newAdLoc: this.newAdLoc,
                    newDepartmentName: this.newDepartmentName
                }).then(() => {
                    vm.alert(ToastType.Success, `AdLoc information was updated successfully`);
                    vm.onEditAdLocClose();
                    vm.loadData();
                }).catch(function (error) {
                    vm.alertMessage.type = "danger";
                    vm.alertMessage.message = error.response.statusText;
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            },

            onEditAccounts(adLoc, ttiAccount) {
              this.adLoc = adLoc.adLoc;
              this.departmentName = adLoc.departmentName;
              this.previousTTIAccountGL = adLoc.ttiAccountGL;
              this.previousTTIAccountSL = ttiAccount.ttiAccountSL;
              this.previousTTIAccountSA = ttiAccount.ttiAccountSA;
              this.previousDepartmentGL = adLoc.departmentGL;
              this.previousDepartmentSL = ttiAccount.departmentSL;
              this.previousDepartmentSA = ttiAccount.departmentSA;
              this.newTTIAccountGL = adLoc.ttiAccountGL;
              this.newTTIAccountSL = ttiAccount.ttiAccountSL;
              this.newTTIAccountSA = ttiAccount.ttiAccountSA;
              this.newDepartmentGL = adLoc.departmentGL;
              this.newDepartmentSL = ttiAccount.departmentSL;
              this.newDepartmentSA = ttiAccount.departmentSA;
              this.isEditAccountsModalVisible = true;
            },

            onEditAccountsClose () {
              this.alertMessage.type = null;
              this.alertMessage.message = null;
              this.adLoc = null;
              this.departmentName = null;
              this.previousTTIAccountGL = null;
              this.previousTTIAccountSL = null;
              this.previousTTIAccountSA = null;
              this.previousDepartmentGL = null;
              this.previousDepartmentSL = null;
              this.previousDepartmentSA = null;
              this.newTTIAccountGL = null;
              this.newTTIAccountSL = null;
              this.newTTIAccountSA = null;
              this.newDepartmentGL = null;
              this.newDepartmentSL = null;
              this.newDepartmentSA = null;
              this.isEditAccountsModalVisible = false;
            },

            onEditAccountsSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.newTTIAccountGL.$invalid
                    || this.$v.newTTIAccountSL.$invalid
                    || this.$v.newTTIAccountSA.$invalid
                    || this.$v.newDepartmentGL.$invalid
                    || this.$v.newDepartmentSL.$invalid
                    || this.$v.newDepartmentSA.$invalid
                ) {
                    return;
                }

                vm.isSubmitting = true;
                AcademicIndirectCostService.updateTTIAndDepartmentAccounts({
                    payPeriodStartDate: this.payPeriodStartDate,
                    adLoc: this.adLoc,
                    departmentName: this.departmentName,
                    previousTTIAccountGL: this.previousTTIAccountGL,
                    previousTTIAccountSL: this.previousTTIAccountSL,
                    previousTTIAccountSA: this.previousTTIAccountSA,
                    previousDepartmentGL: this.previousDepartmentGL,
                    previousDepartmentSL: this.previousDepartmentSL,
                    previousDepartmentSA: this.previousDepartmentSA,
                    newTTIAccountGL: this.newTTIAccountGL,
                    newTTIAccountSL: this.newTTIAccountSL,
                    newTTIAccountSA: this.newTTIAccountSA,
                    newDepartmentGL: this.newDepartmentGL,
                    newDepartmentSL: this.newDepartmentSL,
                    newDepartmentSA: this.newDepartmentSA
                }).then(() => {
                    vm.alert(ToastType.Success, `Account information was updated successfully`);
                    vm.onEditAccountsClose();
                    vm.loadData();
                }).catch(function (error) {
                    vm.alertMessage.type = "danger";
                    vm.alertMessage.message = error.response.statusText;
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            },

            /**
             * @description Downloads the aic account details report
             */
            downloadAICAccountDetailsReport() {
              this.isDownloading = true;
              this.isLoading = true;

              AcademicIndirectCostService.downloadAICAccountDetailsReport(this.payPeriodStartDate, this.fiscalYear)
                  .catch(error => {
                      this.alert(ToastType.Danger, error.response.statusText)
                  })
                  .finally(() => {
                    this.isDownloading = false;
                    this.isLoading = false;
                  });
            }
        },
        created() {
            this.filterOptions.payPeriodStartDate = this.payPeriodStartDate;
            this.loadData();
        },
        validations: {
            newAdLoc: {
              required
            },
            newDepartmentName: {
              required
            },
            newTTIAccountGL: {
              required
            },
            newTTIAccountSL: {
              required
            },
            newTTIAccountSA: {
              required
            },
            newDepartmentGL: {
              required
            },
            newDepartmentSL: {
              required
            },
            newDepartmentSA: {
              required
            }
        }
    }
</script>
  
<style scoped>
  table.accounts-table {
    background-color: rgba(0,0,0,.05) !important;
  }
</style>